module.exports = __webpack_public_path__ + "media/Screenrecorder-2021-10-28-12-10-20-588.c3e0c1b0.mp4";